import { Component, OnInit } from "@angular/core";
import { GenericWidgetComponent } from "../generic-widget/generic-widget.component";
import { SessionService } from "src/app/session.service";
import { DashboardService } from "../../dashboard.service";
import { defaultsDeep, filter, map } from "lodash";
import { UiService } from "src/app/ui/ui.service";
import { addCommasToNumber, UtilService } from "src/app/util/util.service";
import { takeUntil } from "rxjs/operators";

const DEFUALT_PIE_CHART_OPTIONS = {
  grid: {
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
  },
  tooltip: {
    trigger: "item",
    formatter: (params: any, ticket: any, callback: any) => {
      return `<strong>${params.name}</strong>
      <br/>Percent: ${params.percent}%
      <br/>Total: ${addCommasToNumber(params.value)}`;
    },
  },
  series: [
    {
      type: "pie",
      radius: ["50%", "90%"],
      labelLine: {
        show: false,
      },
      label: {
        show: false,
      },
    },
  ],
};

@Component({
  selector: "app-mobile-location-allowed-widget",
  templateUrl: "./mobile-location-allowed-widget.component.html",
  styleUrls: ["./mobile-location-allowed-widget.component.scss"],
})
export class MobileLocationAllowedWidgetComponent extends GenericWidgetComponent {
  mobileLocationChartOption: any;

  constructor(
    private DashboardService: DashboardService,
    private SessionService: SessionService,
    private uiService: UiService,
    private util: UtilService,
  ) {
    super();
  }

  get accountID() {
    return this.SessionService.currentAccountValue!.accountID;
  }

  get accountAppID() {
    return this.SessionService.currentAppValue!.id;
  }

  ngOnInit(): void {}

  ngAfterViewInit() {
    super.ngAfterViewInit();
    this.initData();

    this.filterForm.valueChanges
      .pipe(takeUntil(this.onComponentDestroy))
      .subscribe(() => {
        if (
          this.filterForm.valid &&
          this.filterForm.controls.startDate.value <
            this.filterForm.controls.endDate.value
        ) {
          this.initData();
        }
      });
  }

  initData() {
    this.filterForm.controls.endDate.value.setHours(23, 59, 59);

    this.elementLoader
      .waitForEvent(
        this.DashboardService.getMobileLocationAllowed(
          this.accountID,
          this.accountAppID,
          this.filterForm.controls.startDate.value,
          this.filterForm.controls.endDate.value,
        ),
      )
      .pipe(takeUntil(this.onComponentDestroy))
      .subscribe((res) => {
        const result = res as any;

        this.mobileLocationChartOption = defaultsDeep(
          {
            series: [
              {
                name: "Mobile location permissions",
                data: map(
                  filter(result.breakdown, (r) => {
                    return r.count > 0;
                  }),
                  (r) => {
                    return this.util.formatPermissionBreakdown(r);
                  },
                ),
              },
            ],
          },
          DEFUALT_PIE_CHART_OPTIONS,
        );
      });
  }
}
